import { View } from '@shared/components/View';
import { MBActionButtons } from '@shared/scenes/chat/thread/containers/messageActionButtons';
import { API } from '@shared/types/api';
import classNames from './MessageHoverContent.module.css';

interface MessageHoverContentProps {
  showContent: boolean;
  align: 'left' | 'right';
  message: API.ChatMessageFragment;
  channelSlug: string;
  includeEdit?: boolean;
  reactionPickerAnchorName: string;
}

export function MessageHoverContent({
  showContent,
  align,
  message,
  channelSlug,
  includeEdit = true,
  reactionPickerAnchorName,
}: MessageHoverContentProps) {
  return (
    <View relative className={[classNames.messageHoverContent, showContent && classNames.visible]}>
      <View
        className={[
          classNames.content,
          align === 'left' && classNames.alignLeft,
          align === 'right' && classNames.alignRight,
        ]}
      >
        <View className={classNames.inner}>
          <MBActionButtons
            message={message}
            channelSlug={channelSlug}
            isHovering
            includeEdit={includeEdit}
            reactionPickerAnchorName={reactionPickerAnchorName}
          />
        </View>
      </View>
    </View>
  );
}
